export const DEFAULT_IMAGE_ICON_SIZE = 33;

export const DEFAULT_IMAGE_SIZE = 60;

export const SUB_ITEM_DEFAULT_IMAGE_ICON_SIZE = 22;

export const SUB_ITEM_DEFAULT_IMAGE_SIZE = 40;

export const CROSS_SELL_IMAGE_SIZE = 120;

export const CROSS_SELL_SKELETON_CARD_COUNT = 4;

export const CROSS_SELL_TITLE_MAX_CHARS = 21;
export const CROSS_SELL_DESCRIPTION_MAX_CHARS = 32;

export const CHECKOUT_BI_PAGE_NAME = 'ecomCheckout';
export const CROSS_SELL_BI_COMPONENT_NAME = 'cross-sell';
export const CROSS_SELL_BI_ADD_BUTTON_COMPONENT_NAME = 'cross-sell-add-to-cart';

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const NUMBER_OF_PROJECTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;
export const UPDATE_BILLING_ADDRESS_DEBOUNCE_MS = 400;
export const MAX_GIFT_CARDS = 5;

/** @deprecated */
export const petriSpecs = {
  CheckoutExcludeGoogleAutoComplete: 'specs.ecom.CheckoutExcludeGoogleAutoComplete',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  SupportManualPaymentsOnPaymentRequest: 'specs.ecom.SupportManualPaymentsOnPaymentRequest',
  ShowVoidedErrorMessage: 'specs.ecom.ShowVoidedErrorMessage',
  HideMissingLineItemImagesInPaymentRequest: 'specs.ecom.HideMissingLineItemImagesInPaymentRequest',
  ErrorHandlerOnStorefrontSdk: 'specs.ecom.ErrorHandlerOnStorefrontSdk',
  AddCartServiceToContext: 'specs.ecom.AddCartServiceToContext',
  ExpressLoaderInCheckout: 'specs.ecom.ExpressLoaderInCheckout',
  DeliveryOptionsSetFirstAsDefault: 'specs.ecom.deliveryOptionsSetFirstAsDefault',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  ShowAllSubscriptionItemNames: 'specs.ecom.ShowAllSubscriptionItemNames',
  UpdateCartOnCustomerFieldsChange: 'specs.ecom.UpdateCartOnCustomerFieldsChange',
  PaymentErrorNoCountryHandling: 'specs.ecom.paymentErrorNoCountryHandling',
  SecondaryTitleOnlyInTotalsRow: 'specs.ecom.SecondaryTitleOnlyInTotalsRow',
  SupportMultipleGCInCheckout: 'specs.ecom.SupportMultipleGCInCheckout',
  StoreFullEcomFormUpdateExperiment: 'specs.forms.StoreFullEcomFormUpdateExperiment',
};

export const conductorSpecs = {
  StopSupportingOldPlaceOrderErrorCodes: 'StopSupportingOldPlaceOrderErrorCodes',
  ecomAddPhoneToMarketingConsent: 'ecomAddPhoneToMarketingConsent',
  ecomPlanAndBookInPurchaseFlow: 'ecomPlanAndBookInPurchaseFlow',
  ecomShowCodeSectionWhenApplied: 'ecomShowCodeSectionWhenApplied',
  ecomChargeOrderPaymentRequestApi: 'ecomChargeOrderPaymentRequestApi',
  ecomPlaceOrderFallbackToContinueShoppingUrl: 'ecomPlaceOrderFallbackToContinueShoppingUrl',
  ecomCheckoutPreloadFlow: 'ecomCheckoutPreloadFlow',
  ecomCheckoutCrossSell: 'ecomCheckoutCrossSell',
  ecomSupportTestOrderOnCheckoutPage: 'ecomSupportTestOrderOnCheckoutPage',
  ecomCrossSellStoresItemSelection: 'ecomCrossSellStoresItemSelection',
  ecomMemberDetailsContactAwareSignificance: 'ecomMemberDetailsContactAwareSignificance',
  ecomClearHiddenBillingFieldsBeforeValidation: 'ecomClearHiddenBillingFieldsBeforeValidation',
  ecomBlockPlaceOrderOnFailedCartUpdate: 'ecomBlockPlaceOrderOnFailedCartUpdate',
  ecomFilterHiddenBillingFormValues: 'ecomFilterHiddenBillingFormValues',
  ecomHeadlessCheckoutFetchCartById: 'ecomHeadlessCheckoutFetchCartById',
  ecomSkipDemoUpdateInEditorPreview: 'ecomSkipDemoUpdateInEditorPreview',
  ecomWrapLongPolicyDialogTitle: 'ecomWrapLongPolicyDialogTitle',
  ecomAnalyticsUnitPriceAndCartValue: 'ecomAnalyticsUnitPriceAndCartValue',
  ecomDeduplicatePaymentPolicies: 'ecomDeduplicatePaymentPolicies',
  ecomAcceptAlpha2MemberAddressCountry: 'ecomAcceptAlpha2MemberAddressCountry',
  ecomValidateSavedAddressCountry: 'ecomValidateSavedAddressCountry',
  ecomDisplayBundles: 'ecomDisplayBundles',
  ecomShowUnauthorizedCartAccessError: 'ecomShowUnauthorizedCartAccessError',
  ecomFitCheckoutLayoutOnTablet: 'ecomFitCheckoutLayoutOnTablet',
  ecomRegisterWebMcpTools: 'ecomRegisterWebMcpTools',
};

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
};

export const APPLE_IAP_SITE_PAYMENT_METHOD_TYPE_ID = 'a29ff88e-72fe-481f-b708-f0dfe6004b1c';

export const A11yIds = {
  SummarySection: 'summary-section',
};

export const MANDATORY_FIELDS_HIDDEN = [
  'countryCode',
  'state',
  'email',
  'firstName',
  'lastName',
  'street',
  'houseNumber',
  'address',
  'city',
  'zipCode',
  'phone',
];

export const HOLDER_ID_FIELD = 'holderId';
export const POLICIES_PATH = 'policies';
export const PRELOAD_PATH = 'preloaded';
